<template>
  <v-container>
    <!-- <TargetForSales v-if="this.user.role === 'Sales'" /> -->
    <TargetForRM />
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import TargetForRM from "./TargetForRM";
// import TargetForSales from "./TargetForSales";
export default {
  name: "TargetMain",
  components: {
    TargetForRM,
    // TargetForSales,
  },
  computed: {
    ...mapState(["user"]),
  },
  data: () => ({
    role: "admin",
  }),
};
</script>
